module.exports = __webpack_public_path__ + "static/about_agencyvista3-c2dc39db212aee7c68558125924ff1c9.jpg";